import { SKILLS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import skillsTypes from '../../constants/skillsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'


//
const get_skill_request = () => {
  return {
    type: skillsTypes.get.request
  }
}

const get_skill_success = (response) => {
  return {
    type: skillsTypes.get.request,
    payload: response.data.skill
  }
}

const get_skill_failure = (messages) => {
  return {
    type: skillsTypes.get.failure,
    payload: messages
  }
}

const get_skill = (skill_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_skill_request())

    // Request
    axios.get(
      formatRoute(SKILLS_ROUTES.get, {id: skill_id})
    ).then( response => {
      // success

      dispatch( get_skill_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching skill."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_skill_failure(errors))
    })
  }

}

export {
  get_skill
}



// WEBPACK FOOTER //
// ./src/js/actions/skills/get.js